module.exports = __webpack_public_path__ + "static/media/taxonomyApplicationFailed.e0bbe6c5.png";